module.exports = __webpack_public_path__ + "static/map-b4f8a66d8f2cc2578e997724f1aa9085.svg";